import { Component, computed, input, Signal } from '@angular/core';
import { VulnerabilityIdListComponent } from 'component/details/requirement-intake/requirements-detail/findings/vulnerability/vulnerability-id-list.component';
import { ApiFinding } from 'api';
import {
  DependencyTrackPayload,
  DependencyTrackVulnerability,
} from 'component/details/requirement-intake/requirements-detail/findings/list/findings-list.utils';

@Component({
  selector: 'comp-finding-name',
  templateUrl: 'finding-name.component.html',
  imports: [VulnerabilityIdListComponent],
})
export class FindingNameComponent {
  readonly finding = input.required<ApiFinding>();

  protected readonly vulnerability: Signal<DependencyTrackVulnerability | undefined> = computed(
    () => {
      const aFinding = this.finding();

      if (aFinding.type !== 'DEPENDENCY_TRACK_VULNERABILITY' || !aFinding.data) {
        return undefined;
      }

      try {
        const data = JSON.parse(aFinding.data) as DependencyTrackPayload;
        return data.vulnerability;
      } catch {
        return undefined;
      }
    },
  );
}
